export default function AboutSection() {
  return (
    <section className="w-full bg-gradient-to-b from-secondary-700 via-secondary-800 to-secondary-900 py-20 md:py-28 px-4 md:px-8">
      <div className="max-w-[1400px] mx-auto">
        <div className="mb-20 md:mb-32">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-400/20 text-accent-300 text-xs font-medium tracking-wide mb-6">
            <span className="w-1 h-1 rounded-full bg-accent-400"></span>
            GUIDA SHEET
          </span>
          <h2 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-tight max-w-3xl mb-8">
            Cos'è
            <br />
            Itaobuy Sheet?
          </h2>
          <div className="max-w-2xl space-y-5">
            <p className="text-base md:text-lg text-background-50/80 leading-relaxed">
              Itaobuy Spreadsheet è uno strumento utilizzato dagli utenti per organizzare e scoprire prodotti attraverso liste strutturate contenenti informazioni, categorie e riferimenti utili.
            </p>
            <p className="text-base md:text-lg text-background-50/60 leading-relaxed">
              Il nostro obiettivo è aiutare gli utenti italiani a comprendere come utilizzare Itaobuy Spreadsheet, trovare prodotti interessanti e prendere decisioni migliori. Con oltre 14 categorie di prodotti sempre aggiornate, offriamo una risorsa completa per chi cerca qualità e convenienza.
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          <div className="lg:w-[40%] shrink-0">
            <div className="w-full max-w-sm mx-auto lg:mx-0 aspect-square rounded-2xl bg-background-100 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20spreadsheet%20interface%20on%20a%20sleek%20laptop%20screen%20showing%20organized%20fashion%20product%20data%20with%20colorful%20category%20cards%2C%20sitting%20on%20a%20warm%20oak%20desk%20next%20to%20a%20steaming%20espresso%20cup%2C%20morning%20light%20streaming%20through%20tall%20windows%2C%20Italian%20cafe%20workspace%20aesthetic%2C%20productive%20and%20inviting%20atmosphere&width=800&height=800&seq=about-mockup-v2&orientation=squarish"
                alt="Itaobuy Spreadsheet Interfaccia"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="lg:w-[60%]">
            <div className="font-heading text-8xl md:text-9xl font-bold text-background-50 mb-4">14+</div>
            <p className="text-base md:text-lg text-background-50/70 max-w-md leading-relaxed mb-8">
              Categorie complete di prodotti, organizzate e sempre aggiornate per offrirti la migliore esperienza di ricerca e scoperta su Itaobuy Spreadsheet.
            </p>
            <a
              href="#categories"
              className="inline-flex items-center px-6 py-3 rounded-full bg-background-50 text-foreground-900 text-sm font-semibold whitespace-nowrap transition-all hover:bg-background-100 cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('categories')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Scopri tutte le categorie
              <i className="ri-arrow-down-line ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}